import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://nicrqhzujupacfmbovmy.supabase.co';  // Replace with your project URL
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5pY3JxaHp1anVwYWNmbWJvdm15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkwNjEzNjQsImV4cCI6MjA2NDYzNzM2NH0.cuQgpGo97XRaWLPUEDF3uwrOuH5WikY46ZRPf4rYwwM';                      // Replace with your anon key

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
